import LifeSpa from 'types/ls/lifespa';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationConstant: LtFramework.IAlertNotificationConstant = {
	alertNotificationId: 'alert-notification',
	alertNotificationPrefix: 'alert-notification-',
	alertNotificationSuccess: 'alert-success',
	alertNotificationInfo: 'alert-info',
	alertNotificationWarning: 'alert-warning',
	alertNotificationDanger: 'alert-danger',
	alertNotificationElementId: '.js-alert-notification',
};

export const AlertNotificationModuleConstant: LtFramework.IAlertNotificationModuleConstant = {
	action: {
		synchronize: 'synchronize',
		open: 'open',
		close: 'close',
	},
	getter: {
		getState: 'getState',
	},
	mutation: {
		setAlertNotifications: 'setAlertNotifications',
	},
	name: 'alertNotificationModule',
	state: {
		alertNotifications: 'alertNotifications',
	},
};

export const ClubModuleConstant: LtFramework.IClubModuleConstant = {
	action: {
		setClub: 'setClub',
		synchronize: 'synchronize',
	},
	getter: {
		getState: 'getState',
	},
	mutation: {
		setClub: 'setClub',
	},
	name: 'clubModule',
	state: {
		club: 'club',
	},
};

export const CookieConstant: LtFramework.ICookieConstant = {
	profileToken: 'ltf-profile',
	ssoId: 'LTFSSOIDCookie',
	spabizToken: 'lt-member-spabiz-token',
	spabizTokenExpires: 6480000, // 75 days
};

export const StorageConstant: LtFramework.IStorageConstant = {
	lifespaSlot: 'lt-lifespa-slot',
};

export const EventConstant: LifeSpa.IEventConstant = {
	LifeSpaServiceLoading: 'lifespa-service-loading',
};

export const ProfileModuleConstant: LtFramework.IProfileModuleConstant = {
	action: {
		synchronize: 'synchronize',
	},
	getter: {
		getState: 'getState',
		getIsValid: 'getIsValid',
		getMemberId: 'getMemberId',
	},
	mutation: {
		setProfile: 'setProfile',
	},
	name: 'profileModule',
	state: {
		profile: 'profile',
	},
};

export const MemberStateConstant: LtFramework.IMemberStateConstant = {
	unknown: 'UNKNOWN',
	authenticated: 'AUTHENTICATED',
	unauthenticated: 'UNAUTHENTICATED',
	remembered: 'REMEMBERED',
};

export const UrlModuleConstant: LtFramework.IUrlModuleConstant = {
	action: {
		synchronize: 'synchronize',
	},
	mutation: {
		setUrl: 'setUrl',
	},
	getter: {
		getGlobalPageDriverUrl: 'getGlobalPageDriverUrl',
		getState: 'getState',
		getUrlParameter: 'getUrlParameter',
	},
	name: 'urlModule',
	state: {
		url: 'url',
	},
};

export const ServiceConstant: LtFramework.IServiceConstant = {
	errorMessage: 'Sorry, an unexpected error occured.',
	bookingError: '<strong>Sorry, this appointment is no longer available.</strong><br/>Please review <a href="{{availableBookings}}">Available Bookings</a> to schedule a new service booking.',
};

export const BookingConstant: LtFramework.IBookingConstant = {
	channelId: 9, // Channel ID for Mylt
};
